import { SalesForceCliente } from "../client";
import { IPartnerLeadDataDto } from "./iPartnerLeadDataDto";
import { IUpdateLeadDataDto } from "./iUpdateLeadDataDto";

export class SalesForceService {
  static async authIfNecessary() {
    const hasAuthed =
      !!SalesForceCliente.defaults.headers.common["Authorization"];
    if (!hasAuthed) {
      await this.auth();
    }
  }

  static async auth() {
    const data = {
      client_id: process.env.REACT_APP_SALESFORCE_CLIENT_ID,
      client_secret: process.env.REACT_APP_SALESFORCE_CLIENT_SECRET,
      grant_type: "client_credentials",
    };

    const url = "/services/oauth2/token";
    const response = await SalesForceCliente.post(url, data, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${process.env.REACT_APP_SALESFORCE_ACCESS_TOKEN}`,
      },
    });
    const responseData = response.data;
    SalesForceCliente.defaults.headers.common[
      "Authorization"
    ] = `${responseData.token_type} ${responseData.access_token}`;

    return responseData;
  }

  static async update(data: IUpdateLeadDataDto) {
    await this.authIfNecessary();
    const url = `/services/apexrest/Lead/ExternalId__c/${data.ExternalId__c}`;
    const response = await SalesForceCliente.patch(url, data);
    return response.data;
  }

  static async sendPartnerForm(data: IPartnerLeadDataDto) {
    await this.authIfNecessary();
    const url = `/services/apexrest/Opportunity/`;
    const response = await SalesForceCliente.post(url, data);
    return response.data;
  }
}
